import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {useModelKey} from "@morningtrain/react-resources";
import useAuth from "../hooks/use-auth";

function Is(props) {

    const auth = useAuth();
    const modelKey = useModelKey();

    const shouldRender = () => {

        const id = props.id || modelKey;

        if (id) {
            return auth.is(id, auth.id) !== props.not;
        }

        return false;
    }

    if (shouldRender()) {
        return props.children;
    }

    return null;
}

Is.defaultProps = {
    not: false,
    id: null,
};

Is.propTypes = {
    not: PropTypes.bool,
    id: PropTypes.any,
};

export default observer(Is);
